import { track } from '@amplitude/analytics-browser';
import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss', '../../landing.component.scss']
})
export class FooterComponent implements OnInit {
  constructor(private router: Router) { }

  @Input() noCta: boolean;

  ngOnInit(): void {}

  clickCta() {
    this.router.navigate(['home/contact']);
    track('LANDING_CTA_CLICKED');
  }

}
